import React, { useEffect, useCallback } from 'react'
import { hooks, I18n } from '@front/volcanion'

import { Loader } from '@front/squirtle'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const [, { openDialog }] = hooks.useDialogs()
  const { openNotification } = hooks.useNotification()
  const { EXTERNAL_PHONE_SERVICE } = hooks.useRelayConstants(['EXTERNAL_PHONE_SERVICE'])
  const isReady = hooks.useFormStatus('isReady')
  const [gsm, user_client_id, first_name, last_name] = hooks.useFieldValues(['auth.gsm', 'info.user_client_id', 'info.first_name', 'info.last_name'])
  const [{ group_id, record_id, isManagingRecord, hasPassword, hasGsm }] = hooks.useFormState()
  const unpair = hooks.useSimpleModelFunction('vehicle', 'unpair')

  const [driver] = hooks.useModel('user', [record_id], { single: true })
  const vehicle_id = driver?.vehicle

  const onUnpair = useCallback(Callbacks.onUnpairHandler(unpair, openNotification, vehicle_id, record_id), [unpair, openNotification, vehicle_id, record_id])
  const handleOrangeCall = useCallback(Callbacks.handleOrangeCallHandler(), [])
  const handleCall = useCallback(Callbacks.handleCallHandler(EXTERNAL_PHONE_SERVICE, handleOrangeCall), [EXTERNAL_PHONE_SERVICE, handleOrangeCall])
  const confirmReset = useCallback(Callbacks.confirmResetHandler(openDialog, user_client_id, record_id), [openDialog, user_client_id, record_id])
  const onResetSmsPassword = useCallback(Callbacks.onResetSmsPasswordHandler(confirmReset), [confirmReset])
  const onResetEmailPassword = useCallback(Callbacks.onResetEmailPasswordHandler(confirmReset), [confirmReset])
  const onCallDriver = useCallback(Callbacks.onCallDriverHandler(openDialog, user_client_id, first_name, last_name), [openDialog, user_client_id, first_name, last_name])
  const onKeyDown = useCallback(Callbacks.onKeyDownHandler(gsm, handleCall), [gsm, handleCall])

  const actions = [
    { name: I18n.t('action.reset_password'), iconName: 'sms', onClick: onResetSmsPassword, hidden: !record_id || !hasPassword },
    { name: I18n.t('action.reset_password'), iconName: 'alternate_email', onClick: onResetEmailPassword, hidden: !record_id || !hasPassword },
    { name: I18n.t('action.call_driver'), iconName: 'phone', onClick: onCallDriver, hidden: !record_id || !hasGsm },
    { name: I18n.t('action.unpair'), iconName: 'link_off', onClick: onUnpair, hidden: !vehicle_id }
  ]

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [onKeyDown])

  const mergedProps = {
    actions,
    isManagingRecord,
    group_id,
    handleCall
  }

  return <Loader isLoading={!isReady}>
    <Component {...mergedProps} {...props} />
  </Loader>
}

export default withContainer
